// extracted by mini-css-extract-plugin
export default {"mainLayout":"Login_mainLayout__8pgYp"};